"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.FeefoReviews = void 0;

var _feefoReviews = _interopRequireDefault(require("./components/feefo-reviews"));

exports.FeefoReviews = _feefoReviews["default"];